module.exports = __webpack_public_path__ + "img/bg-careers.1ed89092.png";